import React from 'react';
import ModalDefault from 'v2/components/ModalDefault';
import { IModalGreenfyWhatCanYouDo } from './types';
import useModalCommandSuggestions from './hooks/useModalCommandSuggestions';
import * as SC from './styles';
import Icon from 'v2/components/Icon';
const ModalGreenfyWhatCanYouDo: React.FC<IModalGreenfyWhatCanYouDo> = ({
  isOpen,
  onBack,
  onClose,
}) => {
  const { steps, stepCurrent, handleStepCurrent, handelSetPrompt } =
    useModalCommandSuggestions({
      onClose,
    });
  return (
    <ModalDefault
      title="SUGESTÕES DE COMANDOS"
      iconName="TipsAndUpdatesOutlined"
      isOpen={isOpen}
      onBack={onBack}
      onClose={onClose}
      maxHeight={400}
    >
      <SC.Container>
        <SC.Header>
          {steps.map((item) => (
            <SC.Button
              key={item.id}
              isCurrent={stepCurrent === item.id}
              onClick={() => handleStepCurrent(item.id)}
            >
              {stepCurrent === item.id && <SC.Circle />}
              {item.title}
            </SC.Button>
          ))}
        </SC.Header>

        <SC.Content>
          {steps[stepCurrent].options.map((item) => (
            <SC.Option
              key={item.id}
              onClick={() => handelSetPrompt(item.title)}
            >
              <Icon
                htmlColor={steps[stepCurrent].icon.htmlColor}
                fontSize="medium"
                iconName={steps[stepCurrent].icon.iconName}
              />
              {item.title}
            </SC.Option>
          ))}
        </SC.Content>
      </SC.Container>
    </ModalDefault>
  );
};

export default ModalGreenfyWhatCanYouDo;
